import { useAnalytics } from '@praxis/analytics/client'
import { useAuth } from '@praxis/component-auth'

export const useFirefly = () => {
  const { sendClickEvent, sendViewEvent } = useAnalytics()
  const auth = useAuth()

  const createClickEvent = (key, value, lanId) => {
    const strValue = String(value)
    return {
      event: {
        id: key,
        value: strValue,
      },
      client: {
        employee_login_id: lanId,
      },
    }
  }

  const createViewEvent = (key, value, lanId) => {
    const strVal = String(value)

    return {
      event: {
        id: key,
        value: strVal,
      },
      client: {
        employee_login_id: lanId,
      },
    }
  }

  const handleTrackClickEvent = (key, value) => {
    const lanId = auth?.session?.userInfo?.lanId
    sendClickEvent(key, createClickEvent(key, value, lanId))
  }
  const handleTrackViewEvent = (key, value) => {
    const lanId = auth?.session?.userInfo?.lanId
    sendViewEvent(key, createViewEvent(key, value, lanId))
  }

  return {
    handleTrackClickEvent,
    handleTrackViewEvent,
  }
}
